import type { ContextProviderComponent } from "solid-js";
import { createContext } from "solid-js";
import { initializedContext } from "../utils/initializedUtil";
import { type FieldServiceType } from "./FieldService";
import { type RuleServiceType } from "./RuleService";
import { type FormScope } from "../state/formVersion";
import { type ValidationServiceType } from "./ValidationService";
import { type IntegrationServiceType } from "./IntegrationService";
import type { VariableServiceType } from "./VariableService";

export type FormServices = {
  currentScope: FormScope;
  fieldService: FieldServiceType;
  variableService: VariableServiceType;
  ruleService: RuleServiceType;
  integrationService: IntegrationServiceType;
  validationService: ValidationServiceType;
};
export const FormServicesContext = createContext<FormServices>();
export const FormServicesProvider: ContextProviderComponent<FormServices> = (props) => (
  // oxlint-disable-next-line solid/reactivity -- False-positive, reactivity works as expected
  <FormServicesContext.Provider value={props.value}>{props.children}</FormServicesContext.Provider>
);

export const useFormServices = () => initializedContext(FormServicesContext, "useFormServices", "FieldServiceProvider");
